export default __webpack_public_path__ + "resources/icons/d440-a144.webp";